// Conversations
export const ADD_CONVERSATION = 'ADD_CONVERSATION'
export const SELECT_CONVERSATION = 'SELECT_CONVERSATION'
export const REMOVE_CONVERSATION = 'REMOVE_CONVERSATION'
export const REMOVE_ALL_CONVERSATIONS = 'REMOVE_ALL_CONVERSATIONS'

// User
export const USER_UPDATE = 'USER_UPDATE'
export const USER_UPDATE_CHATMAIL = 'USER_UPDATE_CHATMAIL'

// Composer
export const COMPOSER_EDIT_MESSAGE = 'COMPOSER_EDIT_MESSAGE'
export const COMPOSER_SEND = 'COMPOSER_SEND'
export const COMPOSER_SENT = 'COMPOSER_SENT'
export const COMPOSER_UPLOADING_FILES = 'COMPOSER_UPLOADING_FILES'
export const COMPOSER_ADD_FILES = 'COMPOSER_ADD_FILES'
export const COMPOSER_RESET = 'COMPOSER_RESET'
export const COMPOSER_REMOVE_FILES = 'COMPOSER_REMOVE_FILES'
export const COMPOSER_CHANGE_MESSAGE_TYPE = 'COMPOSER_CHANGE_MESSAGE_TYPE'
export const COMPOSER_SET_REPLY = 'COMPOSER_SET_REPLY'
export const COMPOSER_REMOVE_REPLY = 'COMPOSER_REMOVE_REPLY'
export const COMPOSER_SET_TAG = 'COMPOSER_SET_TAG'
export const COMPOSER_SET_TEMPLATE = 'COMPOSER_SET_TEMPLATE'
export const COMPOSER_EDIT_BUTTONS = 'COMPOSER_EDIT_BUTTONS'
export const COMPOSER_SET_FILES = 'COMPOSER_SET_FILES'
export const COMPOSER_ADD_EXTERNAL_TEXT = 'COMPOSER_ADD_EXTERNAL_TEXT'
export const COMPOSER_SET_CHATMAIL_HEADER = 'COMPOSER_SET_CHATMAIL_HEADER'
export const COMPOSER_SET_REPLY_MESSAGE = 'COMPOSER_SET_REPLY_MESSAGE'
export const COMPOSER_SET_DRAFT_TO_EDIT = 'COMPOSER_SET_DRAFT_TO_EDIT'
export const COMPOSER_SET_CURRENT_SUBJECT = 'COMPOSER_SET_CURRENT_SUBJECT'
export const COMPOSER_SET_SURVEY = 'COMPOSER_SET_SURVEY'
export const COMPOSER_SET_WALL_ENABLED_SMS = 'COMPOSER_SET_WALL_ENABLED_SMS'
export const COMPOSER_SET_VARIABLES = 'COMPOSER_SET_VARIABLES'

// Messages
export const MESSAGES_SUCCESS = 'MESSAGES_SUCCESS'
export const MESSAGES_FAILURE = 'MESSAGES_FAILURE'
export const SET_FILTERED_MESSAGES = 'SET_FILTERED_MESSAGES'
export const MESSAGE_UPDATE = 'MESSAGE_UPDATE'
export const UPDATE_MESSAGE_STATUS = 'UPDATE_MESSAGE_STATUS'

//IA
export const SET_SUGGESTIONS = 'SET_SUGGESTIONS'
export const REJECT_SUGGESTIONS = 'REJECT_SUGGESTIONS'

//Deferred
export const TOGGLE_DEFERRED = 'TOGGLE_DEFERRED'
export const SET_DEFERRED_DATE = 'SET_DEFERRED_DATE'
export const GET_DEFERRED_MESSAGES = 'GET_DEFERRED_MESSAGES'
export const TOGGLE_DEFERRED_SHOWN = 'TOGGLE_DEFERRED_SHOWN'

//Reactions
export const ADD_MESSAGE_REACTION = 'ADD_MESSAGE_REACTION'
export const REMOVE_MESSAGE_REACTION = 'REMOVE_MESSAGE_REACTION'